export const attachmentMenuText = {
  add: { key: 'attachment_add', fallback: { en: 'Add attachment', he: 'הוספת קובץ מצורף' } },
  takePhoto: { key: 'attachment_take_photo', fallback: { en: 'Take a photo', he: 'צילום תמונה' } },
  cameraHint: { key: 'attachment_camera_hint', fallback: { en: 'Use your camera', he: 'באמצעות המצלמה' } },
  uploadPhoto: { key: 'attachment_upload_photo', fallback: { en: 'Upload photo', he: 'העלאת תמונה' } },
  computer: { key: 'attachment_from_computer', fallback: { en: 'From your computer', he: 'מהמחשב שלך' } },
  uploadFile: { key: 'attachment_upload_file', fallback: { en: 'Upload file', he: 'העלאת קובץ' } },
  dropHint: {
    key: 'attachment_drop_hint',
    fallback: { en: 'Or drop an image or file into the conversation.', he: 'אפשר גם לגרור תמונה או קובץ לשיחה.' },
  },
}
